import { Component, inject, OnInit } from '@angular/core';
import { takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { GetEnumValuesDto, SmsCp } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexModule, BaseIndexPageComponent } from '../../shared/base';
import { PrivateNumbersService } from './../../../core/api/services/private-numbers.service';
import { PrivateNumbersFormComponent } from './private-numbers-form/private-numbers-form.component';
import { RangePrivateNumbersFormComponent } from './range-private-numbers-form/range-private-numbers-form.component';
import { TestSendFormComponent } from './test-send-form/test-send-form.component';

@Component({
    selector: 'app-private-numbers',
    templateUrl: './private-numbers.component.html',
    imports: [
        BaseIndexModule,
        PrivateNumbersFormComponent,
        RangePrivateNumbersFormComponent,
    ]
})
export class PrivateNumbersComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.privateNumbers;
  protected currentService = inject(PrivateNumbersService);
  paginationApiMethodName =
    this.currentService.privateNumbersGetPrivateNumbersWithPagination.name;
  auditApiMethodName =
    this.currentService.privateNumbersGetPrivateNumberAudits.name;
  deleteApiMethodName: string = this.currentService.privateNumbersDelete.name;
  createGetApiMethodName: string =
    this.currentService.privateNumbersCreateGet.name;
  SmsSenderAgentCpEnumValues: GetEnumValuesDto[] = [];
  privateNumberId: any;
  isVisibleRangeForm: boolean = false;
  //#endregion

  ngOnInit(): void {
    super.ngOnInit();
    this.pageConfig.showAddBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsSenderAgentCpEnumValues = values));
  } 

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
        wrap: true,
      },
      {
        title: this.localizer.number,
        name: 'number',
        hasSearch: true,
        dir: 'ltr',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}smsSenderAgentName`,
        name: 'SmsSenderAgentName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}smsSenderAgentId`,
        name: 'SmsSenderAgentCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
        wrap: true,
      },
      {
        title: this.localizer.price,
        name: 'price',
        needCurrency: true,
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}sendToBlackList`,
        name: 'sendToBlackList',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isGeneralBlackList`,
        name: 'isGeneralBlackList',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  baseGetByIdApi(id: number): void {
    // this.unSubs();
    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;
    this.currentService
      .privateNumbersUpdateGet({ numberId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  onTestSend(id, smsSenderAgentCp: SmsCp) {
    try {
      this.unSubs();
      this.privateNumberId = id;

      let data = {
        privateNumberId: id,
        isCanSendVoice: smsSenderAgentCp == SmsCp.Avanak ? true : false,
      };

      const modalResult = this.dialogService.openModal({
        component: TestSendFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onCreateByRange() {
    try {
      this.currentService[this.createGetApiMethodName]()
        .pipe(this.basePipeOperators())
        .subscribe(
          (res) => {
            if (res) {
              this.setParentQueryString();

              this.location.go(
                window.location.pathname + '?key-formType=create'
              );
              this.isVisibleRangeForm = true;
            }
          },
          (error) => {
            this.isVisibleRangeForm = undefined;
            const timeout = setTimeout(() => {
              this.isVisibleRangeForm = false;
              clearTimeout(timeout);
            }, 10);
          }
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }
}
